"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var LookupValue_1 = require("../../helpers/LookupValue");
var Tree_1 = require("../../components/Tree");
var CancellationReasonComponent = /** @class */ (function (_super) {
    __extends(CancellationReasonComponent, _super);
    function CancellationReasonComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.getAPCancellationReason = function () {
            var cancellationReason = "";
            if (_this.props.interaction && _this.props.interaction.cancellationReason) {
                cancellationReason = "AP Cancellation Reason: " + (0, jsx_runtime_1.jsx)(LookupValue_1.LookupValue, { type: "cancellationReasons", id: _this.props.interaction.cancellationReason.cancellationReasonCode });
            }
            else if (_this.props.interaction && _this.props.interaction.cancellationReasonInfo
                && _this.props.interaction.cancellationReasonInfo.type === "AGENT") {
                var agentCancellationReason = _this.props.policyVersion.cancellationReason;
                cancellationReason = "AP Cancellation Reason: " + agentCancellationReason.cancellationReasonText;
            }
            return cancellationReason;
        };
        _this.getAPCancellationDetails = function () {
            if (_this.props.policyVersion.cancellationReason && _this.props.policyVersion.cancellationReason.editor) {
                return "Cancelled by: " + _this.props.policyVersion.cancellationReason.editor;
            }
            return "";
        };
        _this.getCustomerCancellationReason = function () {
            var cancellationReasonInfo = [];
            if (_this.props.policyVersion && _this.props.policyVersion.cancellationReason) {
                var cancellationReason = _this.props.policyVersion.cancellationReason;
                cancellationReasonInfo.push((0, jsx_runtime_1.jsxs)("div", { children: ["Customer cancellation reason: ", cancellationReason.cancellationReasonText] }));
                cancellationReason.details && cancellationReasonInfo.push((0, jsx_runtime_1.jsxs)("div", { children: ["Cancellation reason details: ", cancellationReason.details] }));
            }
            return cancellationReasonInfo;
        };
        _this.getUnderwritingResult = function () {
            var underwritingResult = "";
            if (_this.props.interaction && _this.props.interaction.underwritingResult && _this.props.interaction.underwritingResult[0]) {
                underwritingResult = "UW Decline Code: " + _this.collectUWRules();
            }
            return underwritingResult;
        };
        _this.collectUWRules = function () {
            return _this.props.interaction.underwritingResult.map(function (rule) { return (rule.objectName); }).join(", ");
        };
        _this.state = {};
        return _this;
    }
    CancellationReasonComponent.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.props.interaction.cancellationReason || (this.props.interaction.cancellationReasonInfo
                        && this.props.interaction.cancellationReasonInfo.type === "AGENT") &&
                        (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { children: this.getAPCancellationReason() }), (0, jsx_runtime_1.jsx)("div", { children: this.getAPCancellationDetails() })] }), this.props.policyVersion.cancellationReason && this.props.interaction.cancellationReasonInfo
                        && this.props.interaction.cancellationReasonInfo.type !== "AGENT" && this.getCustomerCancellationReason(), this.props.interaction.underwritingResult[0] && (0, jsx_runtime_1.jsx)("div", { children: this.getUnderwritingResult() })] }) }));
    };
    CancellationReasonComponent = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CancellationReasonComponent);
    return CancellationReasonComponent;
}(React.Component));
exports.default = CancellationReasonComponent;
//# sourceMappingURL=CancellationReasonComponent.js.map